import { render, staticRenderFns } from "./portalRealApp.vue?vue&type=template&id=3bac391f"
import script from "./portalRealApp.vue?vue&type=script&lang=js"
export * from "./portalRealApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports